import { render, staticRenderFns } from "./Default.empty.vue?vue&type=template&id=e3679296&"
import script from "./Default.empty.vue?vue&type=script&lang=js&"
export * from "./Default.empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3679296')) {
      api.createRecord('e3679296', component.options)
    } else {
      api.reload('e3679296', component.options)
    }
    module.hot.accept("./Default.empty.vue?vue&type=template&id=e3679296&", function () {
      api.rerender('e3679296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/Default.empty.vue"
export default component.exports